import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Alunos from './pages/Alunos';
import Professores from './pages/Professores';
import Turmas from './pages/Turmas';
// import Agenda from './pages/Agenda'; // Desabilitado temporariamente
import Financeiro from './pages/Financeiro';
import Assinaturas from './pages/Assinaturas';
import Pagamentos from './pages/Pagamentos';
import Relatorios from './pages/Relatorios';
import Configuracoes from './pages/Configuracoes';
import Usuarios from './pages/Configuracoes/Usuarios';
import PerfisAcesso from './pages/Configuracoes/PerfisAcesso';
import DadosEmpresa from './pages/Configuracoes/DadosEmpresa';
import LogoIdentidade from './pages/Configuracoes/LogoIdentidade';
import Contatos from './pages/Configuracoes/Contatos';
import Niveis from './pages/Niveis';
import Avaliacoes from './pages/Avaliacoes';
// Cobranças
import Cobrancas from './pages/cobrancas/Cobrancas';
import Avulsas from './pages/cobrancas/Avulsas';
import AssinaturasCobrancas from './pages/cobrancas/AssinaturasCobrancas';
import AssinaturaDetalhes from './pages/cobrancas/AssinaturaDetalhes';
import CobrancaDetalhes from './pages/cobrancas/CobrancaDetalhes';
import Notificacoes from './pages/cobrancas/Notificacoes';
// Integração FireAgent
import FireAgentConfiguracoes from './pages/integracao/FireAgentConfiguracoes';
import EmbeddedSignup from './pages/integracao/EmbeddedSignup';
import DisparoMensagens from './pages/integracao/DisparoMensagens';
import Templates from './pages/integracao/Templates';
import Consumo from './pages/integracao/Consumo';
import NotFound from './pages/NotFound';

function App() {
  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

  const appContent = (
    <AuthProvider>
      <ThemeProvider>
        <Router>
        <Routes>
          {/* Rota pública */}
          <Route path="/login" element={<Login />} />
          
          {/* Rotas protegidas */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/alunos" element={
            <ProtectedRoute>
              <Layout>
                <Alunos />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/professores" element={
            <ProtectedRoute>
              <Layout>
                <Professores />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/turmas" element={
            <ProtectedRoute>
              <Layout>
                <Turmas />
              </Layout>
            </ProtectedRoute>
          } />
          
          {/* Rota Agenda desabilitada temporariamente
          <Route path="/agenda" element={
            <ProtectedRoute>
              <Layout>
                <Agenda />
              </Layout>
            </ProtectedRoute>
          } />
          */}
          
          <Route path="/financeiro" element={
            <ProtectedRoute>
              <Layout>
                <Financeiro />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/relatorios" element={
            <ProtectedRoute>
              <Layout>
                <Relatorios />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/configuracoes" element={
            <ProtectedRoute>
              <Layout>
                <Configuracoes />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/configuracoes/usuarios" element={
            <ProtectedRoute>
              <Layout>
                <Usuarios />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/configuracoes/perfis-acesso" element={
            <ProtectedRoute>
              <Layout>
                <PerfisAcesso />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/configuracoes/perfis" element={
            <ProtectedRoute>
              <Layout>
                <PerfisAcesso />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/configuracoes/dados-empresa" element={
            <ProtectedRoute>
              <Layout>
                <DadosEmpresa />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/configuracoes/logo-identidade" element={
            <ProtectedRoute>
              <Layout>
                <LogoIdentidade />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/configuracoes/contatos" element={
            <ProtectedRoute>
              <Layout>
                <Contatos />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/niveis" element={
            <ProtectedRoute>
              <Layout>
                <Niveis />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/avaliacoes" element={
            <ProtectedRoute>
              <Layout>
                <Avaliacoes />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/assinaturas" element={
            <ProtectedRoute>
              <Layout>
                <Assinaturas />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/pagamentos" element={
            <ProtectedRoute>
              <Layout>
                <Pagamentos />
              </Layout>
            </ProtectedRoute>
          } />
          
          {/* Rotas de Cobranças */}
          <Route path="/cobrancas" element={
            <ProtectedRoute>
              <Layout>
                <Cobrancas />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/cobrancas/avulsas" element={
            <ProtectedRoute>
              <Layout>
                <Avulsas />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/cobrancas/assinaturas" element={
            <ProtectedRoute>
              <Layout>
                <AssinaturasCobrancas />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/cobrancas/assinaturas/:id" element={
            <ProtectedRoute>
              <Layout>
                <AssinaturaDetalhes />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/cobrancas/detalhes/:id" element={
            <ProtectedRoute>
              <Layout>
                <CobrancaDetalhes />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/cobrancas/notificacoes" element={
            <ProtectedRoute>
              <Layout>
                <Notificacoes />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Rotas de Integração FireAgent */}
          <Route path="/integracao/embedded-signup" element={
            <ProtectedRoute>
              <Layout>
                <EmbeddedSignup />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/integracao/embedded-signup/callback" element={
            <ProtectedRoute>
              <Layout>
                <EmbeddedSignup />
              </Layout>
            </ProtectedRoute>
          } />
          <Route path="/integracao/fireagent/configuracoes" element={
            <ProtectedRoute>
              <Layout>
                <FireAgentConfiguracoes />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/integracao/templates" element={
            <ProtectedRoute>
              <Layout>
                <Templates />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/integracao/consumo" element={
            <ProtectedRoute>
              <Layout>
                <Consumo />
              </Layout>
            </ProtectedRoute>
          } />
          
          <Route path="/integracao/disparo" element={
            <ProtectedRoute>
              <Layout>
                <DisparoMensagens />
              </Layout>
            </ProtectedRoute>
          } />

          {/* Rota catch-all para páginas não encontradas */}
          <Route path="*" element={
            <ProtectedRoute>
              <NotFound />
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
      </ThemeProvider>
    </AuthProvider>
  );

  // Só envolve com reCAPTCHA se a chave estiver configurada
  if (recaptchaSiteKey) {
    return (
      <GoogleReCaptchaProvider
        reCaptchaKey={recaptchaSiteKey}
        scriptProps={{
          async: false,
          defer: false,
          appendTo: 'head',
          nonce: undefined,
        }}
      >
        {appContent}
      </GoogleReCaptchaProvider>
    );
  }

  return appContent;
}

export default App;
